import _ from 'lodash';
import React from 'react';

const withCustomCells = (Component) => {
  const ComponentWithCustomCells = ({ columns, customCells = [], ...otherProps }) => {
    // map custom cells by accessor or column index
    const customCellsMap = customCells.reduce((acc, item) => {
      const { accessor } =
        'index' in item && columns.length > item.index ? columns[item.index] : item;
      return { ...acc, [accessor]: item };
    }, {});

    // compute extra columns
    const extraColumns = _.differenceWith(
      customCells.filter((column) => !('index' in column)),
      columns,
      (config, column) => config.accessor === column.accessor
    );

    // customize columns using cell configs
    const customColumns = columns.concat(extraColumns).map((column) => {
      const cellConfig = customCellsMap[column.accessor];
      const customCell =
        cellConfig && cellConfig.customCell ? cellConfig.customCell(column) : column.customCell;

      return { ...column, customCell };
    });

    return <Component columns={customColumns} {...otherProps} />;
  };

  ComponentWithCustomCells.displayName = `WithCustomCells(${Component.displayName ||
    Component.name ||
    'Component'})`;

  return ComponentWithCustomCells;
};

export default withCustomCells;
